"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackMappedStep = exports.useTrackStep = void 0;
var get_1 = __importDefault(require("lodash/get"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var react_1 = require("react");
var react_final_form_1 = require("react-final-form");
var analytics_1 = require("utils/analytics");
var useTrackStep = function (WizardContext) {
    var _a = (0, react_1.useContext)(WizardContext), stepTrackingEvent = _a.stepTrackingEvent, currentStep = _a.currentStep, stepNumber = _a.stepNumber;
    var track = (0, analytics_1.usePreparedTracker)(stepTrackingEvent, { stepNumber: stepNumber, stepName: currentStep });
    return function (properties) { return track(properties); };
};
exports.useTrackStep = useTrackStep;
var useTrackMappedStep = function (WizardContext, trackingMap) {
    var formValues = (0, react_final_form_1.useFormState)({ subscription: { values: true } }).values;
    var currentStep = (0, react_1.useContext)(WizardContext).currentStep;
    var track = (0, exports.useTrackStep)(WizardContext);
    return function () {
        var _a;
        if (trackingMap === null || trackingMap === void 0 ? void 0 : trackingMap[currentStep]) {
            var properties = (0, mapValues_1.default)((_a = trackingMap[currentStep]) === null || _a === void 0 ? void 0 : _a.fromForm, function (v, k) {
                if (typeof v === 'function')
                    return v(formValues);
                if (v === null || v === void 0 ? void 0 : v.endsWith('.'))
                    return (0, get_1.default)(formValues, "".concat(v).concat(k));
                return (0, get_1.default)(formValues, v || '');
            });
            track(properties);
        }
    };
};
exports.useTrackMappedStep = useTrackMappedStep;
